export default __webpack_public_path__ + "static/media/undeadtext.32b03cab.png";